import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import MissionStatement from "./views/MissionStatement.vue";
import HeftUebersicht from "./views/HeftUebersicht.vue";
import ArtikelArchiv from "./views/Archiv.vue";
import RedaktionBeirat from "./views/RedaktionBeirat.vue";
import Info from "./views/Info.vue";
import Abo from "./views/Abo.vue";
import AutorEntry from "./views/autor/_entry.vue";
import AusgabeEntry from "./views/ausgabe/_entry.vue";
import Meta from 'vue-meta';

Vue.use(Router);
Vue.use(Meta);

export default new Router({

  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/mission-statement",
      name: "missionStatemetn",
      component: MissionStatement,
    },
    {
      path: "/heft-uebersicht",
      name: "heftUebersicht",
      component: HeftUebersicht,
    },
    {
      path: "/artikel-archiv",
      name: "artikel-archiv",
      component: ArtikelArchiv,
    },
    {
      path: "/redaktion-beirat",
      name: "redaktionBeirat",
      component: RedaktionBeirat,
    },
    {
      path: "/info",
      name: "info",
      component: Info,
    },
    {
      path: "/abo",
      name: "abo",
      component: Abo,
    },
    {
      path: "/autor/:slug",
      name: "autorEntry",
      component: AutorEntry,
    },
    {
      path: "/ausgabe/:slug",
      name: "ausgabeEntry",
      component: AusgabeEntry,
    },
  ],
});
